import React from 'react';
import PropTypes from 'prop-types';

import ItemsListEditor from './items-list-editor';

export default class DropdownOptionsEditor extends React.Component {

    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,

        addLabel: PropTypes.string,
        colorSelectionEnabled: PropTypes.bool,
    };

    static defaultProps = {
        colorSelectionEnabled: false
    }

    constructor(props) {
        super(props);

        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue, newIncSeedValue) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue);
    };

    render() {

        const options = this.props.form.getValue(this.props.name);

        return <ItemsListEditor className={this.props.className}
                                items={options}
                                colorSelectionEnabled={this.props.colorSelectionEnabled}
                                addLabel={this.props.addLabel}
                                onChange={this.onChange}/>;
    }
}
